import React, { useState } from "react";
import {
  PiChartBar,
  PiCube,
  PiCubeFocus,
  PiFolderNotchOpen,
  PiHammer,
  PiUser,
} from "react-icons/pi";
import { Outlet, useLocation } from "react-router-dom";
import SecondNavBar from "../../components/SecondNavBar/SecondNavBar";

export const FreeSecondNavBarContext = React.createContext();

const Production = () => {
  const location = useLocation();
  const [freeRef, setFreeRef] = useState(null);

  const handleFreeSecondNavBarRef = (freeSecondNavBarRef) => {
    setFreeRef(freeSecondNavBarRef.current);
  };

  const links = [
    {
      to: "produits",
      icon: <PiCube size={"1.5em"} />,
      text: "Etat production",
      type: "link",
    },
    {
      to: "/",
      icon: <PiFolderNotchOpen size={"1.5em"} />,
      text: "Gestion",
      type: "dropdown",
      links: [
        {
          to: "operateurs",
          icon: <PiUser size={"1.5em"} />,
          text: "Opérateurs",
        },
        {
          to: "stockages",
          icon: <PiCubeFocus size={"1.5em"} />,
          text: "Stockages",
        },
        {
          to: "postes",
          icon: <PiHammer size={"1.5em"} />,
          text: "Postes",
        },
      ],
    },
    {
      to: "statistiques",
      icon: <PiChartBar size={"1.5em"} />,
      text: "Statistiques",
      type: "link",
    },
  ];

  return (
    <FreeSecondNavBarContext.Provider value={freeRef}>
      <SecondNavBar links={links} setRef={handleFreeSecondNavBarRef} />
      <Outlet />
    </FreeSecondNavBarContext.Provider>
  );
};

export default Production;
